import { sendSystemMessageRequestBody } from 'all-in-one-shared-api';
import moment from 'moment';

export interface SystemAnnouncementFormState {
  title: string;
  dateRange: [Date, Date];
  message: string;
}

export class AdminUtils {
  static mapSendSystemMessage(data: SystemAnnouncementFormState): sendSystemMessageRequestBody {
    return {
      message: data.message,
      messageZh: data.message,
      effectiveDate: data.dateRange
        ? moment(data.dateRange[0]).utcOffset(0, true).startOf('day').toISOString().slice(0, -1)
        : '',
      expiryDate: data.dateRange
        ? moment(data.dateRange[1]).utcOffset(0, true).endOf('day').toISOString().slice(0, -1)
        : '',
    };
  }
}
